import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/scans/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.scans.list
const { onChangePagination } = rootActions.ui.scans

function* listScanSagaTask({ payload }: TaskAction) {
    try {
        const params = yield getParams(payload)

        const response = yield axios.get(`/companies/scan`, {
            params
        })

        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(
                onChangePagination({
                    total: response.result.total
                })
            )
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listScanSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listScanSagaTask)
}

export default listScanSaga
